import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import PagesService from '@/services/CmsServices/PagesService';
import { extractError } from '@/helpers/extractApiError';

const model = {
    data: [],
    loading: false,
    error: null,
};

export const getPageList = createAsyncThunk(
    'pages/getPageList',
    async (data, thunkApi) => {
        try {
            const response = await PagesService.getPageList(data);
            return response.data;
        } catch (error) {
            return thunkApi.rejectWithValue(extractError(error));
        }
    },
);

const pageListSlice = createSlice({
    name: 'pageList',
    initialState: model,
    reducers: {},
    extraReducers: (builder) => {
        // get page list
        builder.addCase(getPageList.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(getPageList.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        });
        builder.addCase(getPageList.rejected, (state, action) => {
            state.loading = false;
            state.error = extractError(action);
        });
    },
});

export default pageListSlice.reducer;
